// Build a project's runtime config from its provisioning manifest.
//
// The LOGIC lives in the SDK now — `configFromManifest` / `isProjectFederated`
// in @s3p/sdk/contracts — so every multi-project surface (this console, any
// operator tool) synthesizes the same config the same way. This file only
// binds the platform's own boot config (this origin's /__s3p/project.js) as
// the `platform` argument.
//
// SECURITY: the config is not authority. It names pools and buckets; it
// grants nothing. The console signs into the PLATFORM pool and exchanges that
// token at the target project's Identity Pool, which maps
// `{slug}:operator-owner|-admin` to that project's role and Denies everyone
// else. Handing the console a config for a project you don't operate yields
// no credentials.

import { s3pProject as platformConfig } from "/__s3p/project.js";
import {
  configFromManifest as sdkConfigFromManifest,
  isProjectFederated,
} from "/sdk/index.js";
import type { ProjectManifest, ResolvedProjectConfig } from "@s3p/sdk";

/** The resolved config the embedded console boots with (SDK ProjectConfig). */
export type ProjectRuntimeConfig = ResolvedProjectConfig;

export function configFromManifest(m: ProjectManifest): ProjectRuntimeConfig {
  return sdkConfigFromManifest(m, platformConfig);
}

/** Can this project's console actually be opened by a platform identity?
 *  Root always; others need federation WIRED (see the SDK's doc). */
export const isFederated: (m: ProjectManifest) => boolean = isProjectFederated;
